<template lang="pug">
  .c-popup(v-show="param.popup" @click="param.popup = false")
    .c-popup__operate.col-24.color-white.flexD.flexDirectionRow.justifySpaceBetween.alignItemsCenter.m-width-90.m-maxWidthNone(@click="stopPropagation($event)")
      .width10EM
      .flexD.flexDirectionRow.alignItemsCenter.font-title
        .width2EM.textAlignCenter
          i.fa.fa-close.cursorPointer(@click="param.popup = false")
      a.cursorPointer.font-section.width10EM.color-white.textDecorationNone(:href="pdf" target="_blank" download)
        i.fa.fa-download.lineHeight2EM(style="font-size: 1.5em")
    .c-popup__content.m-width-90.m-maxWidthNone(@click="stopPropagation($event)")
      .col-24.bgColor-white.textAlignLeft.flexD.flexDirectionRow.justifySpaceBetween(style='padding: 0')
        embed(:src="pdf" width="100%" height="2000" style='max-height:calc(100vh - 7em)')
</template>

<script>
  export default {
    name: 'popupWibo',
    props: ['content'],
    data(){
      return{
        param: {
          popup: false,
          index: 0
        },
        pdf: "./doc/wibo_pdf.pdf",
        // pdf: require('@/assets/document/wibo_pdf.pdf')
      }
    },
    computed: {},
    watch: {
      content(data) {
        this.param = data
      }
    },
    methods:{
      stopPropagation(e){
        if (e.stopPropagation) {
          e.stopPropagation();
        } else {
          e.cancelBubble = true;
        }
      },
      prevPage(){
        this.param.index -= 1
      },
      nextPage(){
        this.param.index += 1
      }
    },
    created(){}
  }
</script>
